<div class="parallax-bubbles bg-color-primary"></div>
<div class="signin-container">
  <div>
    <new-sign-up-card
      class="sign-up-card"
      role="main"
      [showSignIn]="true"
      [showRegister]="true"
      (signIn)="signIn($event)"
      (confirmAccount)="confirmAccount($event)"
      (forgotPassword)="forgotPassword($event)"
    ></new-sign-up-card>
  </div>
</div>
<app-footer />
